import * as d3 from 'd3'
import { icon_class } from './constant.js'
import { plot_value } from './variable.js'

//////////////////////////////////////////////////////////////////
// Generate feature option
//////////////////////////////////////////////////////////////////

export function gen_feature_option(option_id, option_text, text_color) {

  // Check icon
  let check_icon_g = d3.select(`#feature-${option_id}-icon`)
    .append('g')
    .attr('id', `feature-${option_id}-check-icon`)
    .style('display', 'inline-block')
    .on('click', function() {
      d3.select(this).style('display', 'none')
      d3.select(`#feature-${option_id}-uncheck-icon`).style('display', 'inline-block')
      plot_value['selected'][option_id] = true
      d3.select(`#plot-line-${option_id}`).style('display', 'none')
      d3.select(`#plot-dots-${option_id}`).style('display', 'none')
    })

  let check_icon = check_icon_g
    .append('i')
    .attr('class', icon_class['check'])
    .style('cursor', 'pointer')

  // Uncheck icon
  let uncheck_icon_g = d3.select(`#feature-${option_id}-icon`)
    .append('g')
    .attr('id', `feature-${option_id}-uncheck-icon`)
    .style('display', 'none')
    .on('click', function() {
      d3.select(this).style('display', 'none')
      d3.select(`#feature-${option_id}-check-icon`).style('display', 'inline-block')
      plot_value['selected'][option_id] = false
      d3.select(`#plot-line-${option_id}`).style('display', 'inline-block')
      d3.select(`#plot-dots-${option_id}`).style('display', 'inline-block')
    })

  let uncheck_icon = uncheck_icon_g
    .append('i')
    .attr('class', icon_class['uncheck'])
    .style('cursor', 'pointer')

  // Text
  let text = document.getElementById(`feature-${option_id}-text`)
  text.innerText = option_text
  text.style.color = text_color

}

export function move_options() {
  d3.select('#feature-benign_avg_delta')
    .style('transform', 'translate(45px, 135px')

  d3.select('#feature-attacked_avg_delta')
    .style('transform', 'translate(45px, 160px')
}